@use 'vars';
@use 'mixins';

@import 'typography/softphone';

.login {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 30px;
  gap: 30px;

  &--softphone {
    @include softphone-typography;

    padding: 15px;
  }

  &--small-softphone {
    padding: vars.$padding-small;
  }

  &__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &__logo {
      width: 100%;
      margin-bottom: 20px;
    }

    &__container {
      &--softphone {
        flex-grow: 1;
      }
    }
  }

  &__info {
    min-width: 50%;
    flex: 1;
    border-radius: 20px;
    background: vars.$light-grey;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
